const state = {
  sidebar: {
    opened: true
  }
}

const mutations = {
  TOGGLE_SIDEBAR: state => {
    console.log('TOGGLE_SIDEBAR mutation called, current state:', state.sidebar.opened)
    state.sidebar.opened = !state.sidebar.opened
    console.log('After mutation, new state:', state.sidebar.opened)
  }
}

const actions = {
  toggleSideBar({ commit }) {
    console.log('toggleSideBar action called')
    commit('TOGGLE_SIDEBAR')
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
} 